import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Alert } from '@whitelabel/component-library';
import { XPAY_PAYPAL_MESSAGE_SUCCESS } from '@whitelabel/xcover-shared/helpers/constants';
import { XpayPaypalMessage } from '../../helpers/types';
import messages from './messages';

const XpayPaypalAlert = () => {
  const intl = useIntl();
  const location = useLocation<{ xpayPaypalMessage?: XpayPaypalMessage }>();

  if (!location.state || !location.state.xpayPaypalMessage) {
    return null;
  }

  const isPaypalConnectSuccessful = location.state.xpayPaypalMessage === XPAY_PAYPAL_MESSAGE_SUCCESS;

  return (
    <Alert color={isPaypalConnectSuccessful ? 'success' : 'danger'}>
      {isPaypalConnectSuccessful
        ? intl.formatMessage(messages.xpayPaypalSuccess)
        : intl.formatMessage(messages.xpayPaypalError)}
    </Alert>
  );
};

export default XpayPaypalAlert;
